export default function useTestHelper() {
  const getServiceIcon = (service_type: any) => {
    let icon = "";

    switch (service_type) {
      case "everywhere-nurse-service":
        icon = "/icons/services/nurse-everywhere.svg";
        break;
      case "instant-test":
        icon = "/icons/services/clinic-instant.svg";
        break;
      case "home-test-kit":
        icon = "/icons/services/home-test.svg";
        break;
      default:
        icon = "/icons/services/clinic-test.svg";
        break;
    }

    return icon;
  };

  const getTitleBarBackground = (service_type: any) => {
    let tBackgroundColor = "";

    switch (service_type) {
      case "clinic-test":
        tBackgroundColor = "bg-space-cadet";
        break;
      case "instant-test":
        tBackgroundColor = "bg-pantone";
        break;
      case "home-test-kit":
        tBackgroundColor = "bg-liberty";
        break;
      default:
        tBackgroundColor = "bg-antigua";
        break;
    }
    return tBackgroundColor;
  };
  return {
    getServiceIcon,
    getTitleBarBackground,
  };
}
